export * from './quick-stake-mini';